"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoChannelEvents = void 0;
var events_1 = require("events");
var Logger_1 = __importDefault(require("./Logger"));
var InfoChannelEvents;
(function (InfoChannelEvents) {
    InfoChannelEvents["OPEN"] = "OPEN";
    InfoChannelEvents["CLOSE"] = "CLOSE";
    InfoChannelEvents["MESSAGE"] = "MESSAGE";
})(InfoChannelEvents || (exports.InfoChannelEvents = InfoChannelEvents = {}));
var InfoChannel = /** @class */ (function (_super) {
    __extends(InfoChannel, _super);
    function InfoChannel(serverUrl, ticket, key, protocol) {
        if (protocol === void 0) { protocol = 'ws'; }
        var _this = _super.call(this) || this;
        _this.serverUrl = serverUrl;
        _this.ticket = ticket;
        _this.key = key;
        _this.protocol = protocol;
        _this.socket = null;
        _this.connect();
        return _this;
    }
    /**
     * Connect to websocket
     */
    InfoChannel.prototype.connect = function () {
        var _this = this;
        this.socket = new WebSocket("".concat(this.protocol, "://").concat(this.serverUrl, "/minfo?t=").concat(this.ticket, "&key=").concat(this.key));
        this.socket.onopen = function () {
            _this.emit(InfoChannelEvents.OPEN, {
                server: _this.serverUrl,
                ticket: _this.ticket,
                key: _this.key,
            });
        };
        this.socket.onmessage = function (e) {
            try {
                var message = JSON.parse(e.data);
                _this.emit(InfoChannelEvents.MESSAGE, {
                    data: message,
                    ticket: _this.ticket,
                });
            }
            catch (ex) {
                Logger_1.default.log('Failed to parse JSON', ex);
            }
        };
        this.socket.onclose = function (e) {
            _this.emit(InfoChannelEvents.CLOSE, {
                server: _this.serverUrl,
                ticket: _this.ticket,
                key: _this.key,
                code: e.code,
            });
        };
    };
    /**
     * Close websocket connection
     */
    InfoChannel.prototype.close = function () {
        if (this.socket) {
            this.socket.close();
        }
        this.socket = null;
    };
    return InfoChannel;
}(events_1.EventEmitter));
exports.default = InfoChannel;
//# sourceMappingURL=InfoChannel.js.map